import React from 'react'
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import ReactPlayer from 'react-player'
import { useSelector } from 'react-redux'
import { NavLink, useHistory } from 'react-router-dom'
import DimondsEaringVideo from '../../../Assets/images/DFL/ring-earing-img/dimonds-earing-video.mp4'
import SelectionImg1 from '../../../Assets/images/DFL/ring-earing-img/earrings-01.1.jpg'
import SelectionImg2 from '../../../Assets/images/DFL/ring-earing-img/earrings-01.2.jpg'
import SelectionImg3 from '../../../Assets/images/DFL/ring-earing-img/earrings-04.jpg'
import DimondEaringJewwelery from '../../../Assets/images/DFL/ring-earing-img/dimond-jewelery.jpg'
import { useMediaQuery } from 'react-responsive'
const DiamondEarrings = () => {
    const history = useHistory()
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    const isBigScreen = useMediaQuery({ query: '(min-width: 1024px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails?.title}</title>
                <meta name="description" content={metaDetails?.description}></meta>
                <meta name="keywords" content={metaDetails?.keywords}></meta>
            </Helmet>

            <div className='dfl_EngagementRingsToronto_secction dfl_diamond_earing_section'>
                <div className='dfl_book_an_Ap_section'>
                    <Container fluid>
                        <Row>
                            <Col sm={12} md={8} lg={8}>
                                <div className='dfl_et_list_left'>
                                    <ul>
                                        <li>Largest Certified <span>Natural</span>  and <span>Lab Grown </span>Diamond inventory.</li>
                                        <li>1000's of Engagement Ring Styles.</li>
                                        <li>Huge diamond jewelery selection.</li>
                                    </ul>
                                </div>
                            </Col>
                            <Col sm={12} md={4} lg={4} className="dfl_book_an_Ap_OUTER">
                                <div className='dfl_btn_dfl_bbok_box'>
                                    <button className="dfl_btn_dff_book" onClick={() => history.push("/make-an-appointment")}>Book Your Free Consulation</button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <div className='dfl_dimond_banner_video_section'>
                <Container>
                    <Row>
                        <Col sm={12} md={6} lg={6}>
                            <div className='dfl_diamonddd_text_outer_box'>
                                <h1>YOUR #1 SOURCE FOR EXQUISITE DIAMOND EARRINGS IN TORONTO, CANADA</h1>
                                <p>Choose the most elegant and one-of-a-kind diamond earrings from our wide selection and wear them for a special occasion that matches your fashion-sense, taste, and mood.</p>
                                <p>Whether you are looking for diamond dangling earrings or diamond stud earrings in Toronto, Diamonds for Less has got you covered. Once you find the right pair, it can go a long way to compliment the look of the person wearing them. A pair of diamond earrings’ unique shape, colour, and precious metal can greatly accent the wearer in very dramatic ways –or even pull away from the sought-after appearance and style the wearer is looking to achieve if not paired just so.</p>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6} className='dfl_dimond_earing_video_box'>
                            <div className='dfl_video_player'>
                                {isBigScreen && <ReactPlayer
                                    url={DimondsEaringVideo}

                                    poster="https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM="
                                    playing
                                    loop
                                    muted
                                    controls={false}
                                    playsinline
                                    preload="none"
                                    className=""
                                    width="100%"
                                    height="300px"
                                />
                                }
                                {isTabletOrMobile && <ReactPlayer
                                    url={DimondsEaringVideo}

                                    poster="https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM="
                                    playing
                                    loop
                                    muted
                                    controls={false}
                                    playsinline
                                    preload="none"
                                    className=""
                                    width="100%"
                                    height="180px"
                                />
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='dfl_dimond_earing_consider_Section'>
                <Container>
                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            <div className='dfl_consider_text'>
                                <p><strong>CONSIDER THESE POINTS WHEN RESEARCHING DIAMOND EARRINGS IN TORONTO.</strong></p>
                                <p>IF YOU’RE SHOPPING FOR DIAMOND EARRINGS AND YOU NEED A LITTLE BIT OF HELP CHOOSING, CONSIDER THE FOLLOWING SUGGESTIONS TO MATCH UP A SUITABLE DIAMOND CUT WITH FACIAL STRUCTURE AND COMPLEXION OF ITS WEARER.</p>
                                <h6 className='mt-5'>IT’S AS EASY AS 1, 2, 3…</h6>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='dfl_dimond_earing_choose_from_our_selection'>
                <Container>
                    <Row>
                        <Col sm={12} md={4} lg={4}>
                            <div className='dfl_dimond_earing_selection_text_img'>
                                <Image src={SelectionImg1} alt="Selection Image" className='img-fluid' />
                                <p>Choose from our selection of impecable style, or consult with one of our Custom Specialist.</p>
                            </div>
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                            <div className='dfl_dimond_earing_selection_text_img'>
                                <Image src={SelectionImg2} alt="Selection Image" className='img-fluid' />
                                <p>Select your diamonds in the shape. carat, clarity, colour and cut of your desire.</p>
                            </div>
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                            <div className='dfl_dimond_earing_selection_text_img'>
                                <Image src={SelectionImg3} alt="Selection Image" className='img-fluid' />
                                <p>Sit back, relax and within one hour be dazzled with your new appraised carrings.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='dfl_dimond_banner_video_section'>
                <Container>
                    <Row>
                        <Col sm={12} md={6} lg={6} className='dfl_dimond_earing_video_box'>
                            <div className='dfl_dimond_rearing_img_box'>
                                <Image src={DimondEaringJewwelery} alt="Selection Image" className='img-fluid' />
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                            <div className='dfl_diamonddd_text_outer_box'>
                                <p>In order to get the very best balance of colour and shape, one might wish to consider the wearer’s facial structure and skin tone. As an example, a wearer of a diamond earring who possesses an angular or sharp facial structure that is a little more rectangular or square-edged may be best suited for round curves within their jewellery pieces.</p>
                                <p>Hoop earrings or round diamond cuts within jewellery will soften the edges of any complexion, and a hard-edged jewellery piece will offset a rounded facial structure by adding some hard edges. <NavLink to="#">Learn more about different face & earring combinations.</NavLink>
                                </p>
                                <p>Cool shades of skin tones will stand out with white gold or platinum. Warm skin tone shades will look glamorous when paired with more elaborate precious metals such as yellow gold, or rose gold.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='dfl_diamion_earing_text_popular'>
                <Container>
                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            <div className='dfl_diamonddd_text_outer_box'>
                                <h6>WHAT ARE THE POPULAR STYLES OF DIAMOND EARRINGS?</h6>
                                <p>You can always add beautiful sparkle and shine to any of your looks with a pair of diamond earrings from Diamonds for Less. We have a wide range that includes a variety of styles and diamond cuts that can complement any style.</p>
                                <p>Diamond hoops have been in style for a few years with no signs of stopping. But if big and bold isn’t your style, then you can choose from our collection of classic diamond studs or our uniquely shaped diamond studs.. And if you want to add a splash of colour, you can always take a look at our colourful gemstone earrings to give you that glimmer you’re looking for.</p>
                                <p>A pair of diamond earrings are great for bringing beautiful and versatile style to your wardrobe, as well as being great as a piece for a special occasion, or gift for someone special. <NavLink to="#" onClick={() => window.open(" https://www.diamondsforless.ca/top-10-diamond-earring-trends-2020/", "_blank")}> Here is a great blog post about popular diamond earring trends.</NavLink>
                                </p>
                                <h6 className='pt-4'>HOW SHOULD I STYLE MY DIAMOND EARRINGS?</h6>
                                <p>You can always find a pair of diamond earrings to match your style. They are as versatile as they are gorgeous. Diamond studs are classic little gems that are understated but beautiful, and they can complement any outfit on any occasion.</p>
                                <p>Dangling diamond earrings or diamond hoop earrings add a bit more glitz and glamour and do well paired with a more modern and elegant look.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='dfl_dimond_earing_experts_help_section'>
                <Container>
                    <Row>
                        <Col sm={12} md={9} lg={9}>
                            <div className='dfl_diamonddd_text_outer_box'>
                                <h6>LET OUR EXPERTS HELP YOU PICK THE BEST DIAMOND EARRINGS IN OUR TORONTO STORE!</h6>
                                <p>If you’re still having a hard time picking the best diamond earrings in Toronto, let our diamond experts help you. We have a dedicated team ready to assist you with all your jewellery concerns whether it’s getting the right cut or simply finding one that complements your look. <NavLink to="#">Visit our brick and mortar store now </NavLink> for a one-of-a-kind diamond shopping experience. <a href='tel:+1 4163629944'>Contact us today.</a></p>

                            </div>
                        </Col>
                        <Col sm={12} md={3} lg={3} className="dflex_align">
                            <div className='btn_box'>
                                <button className='dfl_see_full_article_btn'><a href='tel:+1 4163629944' className='text-black'>416.362.9944</a></button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='dfl_static_looking_somthing_special_section'>
                <Container>
                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            <div className='dfl_look_headding'>
                                <h6 className='w-75'>HAVEN’T FOUND WHAT YOU ARE LOOKING FOR?<NavLink to="#" onClick={() => window.open("https://www.diamondsforless.ca/custom-jewelry-toronto-2/", "_blank")}> PLEASE VISIT OUR CUSTOM JEWELLERY PAGE!</NavLink> </h6>
                                <p>CONTACT US FOR ASSISTANCE OR CUSTOMER ORDERS.</p>
                                <a href='tel:4163629944' className='dfl_see_full_article_btn text-black'>416.362.9944</a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    )
}

export default DiamondEarrings